import React from 'react';
import { toJS } from 'mobx';

import { DateViewer } from '.';
import { BooleanViewer } from '.';
import { IntegerViewer } from '.';
import { FloatViewer } from '.';
import { PercentViewer } from '.';
import { LengthViewer } from '.';
import { PlainViewer } from '.';

export var ValueViewer = function ValueViewer(props) {
  switch (props.field.dataType || 'text') {
    case 'date':
      return React.createElement(DateViewer, props);
    case 'boolean':
      return React.createElement(BooleanViewer, props);
    case 'integer':
      return React.createElement(IntegerViewer, props);
    case 'float':
      return React.createElement(FloatViewer, props);
    case 'percent':
      return React.createElement(PercentViewer, props);
    case 'length':
      return React.createElement(LengthViewer, props);

    case 'custom':
      return null;
    case 'select':
      return null;
    case 'link':
      return null;

    default:
      {
        if (props.field.dataType) console.log(toJS(props.field));
        return React.createElement(PlainViewer, props);
      }
  }
};